import React from 'react';
import './Amenities.css';
import { Helmet } from 'react-helmet';

const AboutSection = () => {
  return (
   <>

<Helmet>
 
 <script type="application/ld+json">
   {JSON.stringify({
     "@context": "https://schema.org",
     "@type": "Organization",
     "name": "Om Sai PG",
     "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
     "url": "https://www.omsaipg.in",
     "logo": "https://www.omsaipg.in/images/logo.jpg",
     "image":"https://www.omsaipg.in/images/ogimage.jpg",
     "contactPoint": [
       {
         "@type": "ContactPoint",
         "telephone": "+91 9763888448",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
       {
         "@type": "ContactPoint",
         "telephone": "+91 9922248255",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
     ],
     "aggregateRating": {
       "@type": "AggregateRating",
       "bestRating": "5",
       "worstRating": "1",
       "ratingValue": "4.7",
       "ratingCount": "250",
     },
     "email": "omsaipg@gmail.com",
     "address": {
       "@type": "PostalAddress",
       "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
       "addressLocality": "Kharadi",
       "addressRegion": "Maharashtra",
       "postalCode": "411014",
       "addressCountry": "IN",
     },
     "sameAs": [
       "https://www.facebook.com/omsaipg",
       "https://www.instagram.com/omsaipg",
       "https://www.linkedin.com/company/omsaipg"
     ],
     "priceRange": "INR 8,500-6000",
     "paymentAccepted": "Cash, UPI, Credit Card",
     "telephone": "+91 9763888448",
     "email": "omsaipgpune@gmail.com",
     "keywords": [
       "PG in Pune",
       "PG in Kharadi",
       "PG with food in Pune",
       "PG for students in Kharadi",
       "PG for females in Pune",
       "PG for males in Pune",
       "Om Sai PG Kharadi",
       "Girls Hostels in Kharadi",
       "Boys Hostel in Kharadi",
       "Monthly Basis PG in Kharadi",
       "PG in Wagholi",
       "PG in Kharadi with food",
       "Hostels in Pune",
       "PG for Students in Kharadi Pune",
       "Paying Guest Hostel in Chandan Nagar"
     ],
     "openingHours": "Mo-Su 09:00-22:00"
   })}
 </script>

 {/* Title */}
 <title>
   Contact : +91 9763888448 / +91 9922248255 | About| Wadgaon Sheri PG | PG in in Chandan Nagar | Hostels in Kharadi
 </title>

 {/* Meta Tags */}
 <meta
   name="description"
   content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
 />
 <meta
   name="keywords"
   content="Monthly Basis PG in Kharadi, PG in Wagholi, PG in Kharadi with food, Hostels in Pune, PG for Students in Kharadi Pune, Paying Guest Hostel in Chandan Nagar"
 />
 <meta name="robots" content="index, follow" />

 {/* Open Graph Tags */}
 <meta
   property="og:title"
   content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
 />
 <meta
   property="og:description"
   content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
 />
 <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
 <meta property="og:url" content="https://www.omsaipg.in" />
 <meta property="og:type" content="website" />
</Helmet>

   

    <section className="section-about padding-tb-50">
      <div className="container">
        <div className="row mb-minus-24 container">
          {/* About Image Section */}
          <div className="col-lg-6 col-12 mb-24" data-aos="fade-up" data-aos-duration="1000">
            <div className="rx-about-img about-img">
              <img src="img/about/about.jpg" alt="about" className="rx-white-img" />
              <div className="rx-rounded-circle">
                <a href="about.html">
                  <svg viewBox="0 0 100 100" width="100" height="100">
                    <defs>
                      <path id="circle" d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0"></path>
                    </defs>
                    <text>
                      <textPath xlinkHref="#circle">
                        About Us - About Us - About -
                      </textPath>
                    </text>
                  </svg>
                  <div className="inner-contact">
                    <i className="ri-arrow-right-up-line"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>

          {/* About Text and Statistics Section */}
          <div className="col-lg-6 col-12 mb-24" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
            <div className="rx-about-contact">
              <div className="rx-banner">
                <p>Where Comfort Meets Convenience</p>
                <h4>
                  
                    Om Sai <span>PG</span>
                </h4>
              </div>
              <div className="inner-contact">
                <p>
                Located in the vibrant heart of the city Kharadi, Om Sai PG offers a perfect blend of comfort and convenience for students and professionals alike. Our well-designed living spaces combine modern facilities with a warm, homely atmosphere, ensuring a restful stay. Whether you're looking for peaceful solitude or a supportive community, Om Sai PG caters to all your needs, providing a safe and welcoming environment. Experience the ease of modern living with all essential amenities, making it the ideal choice for anyone looking for a reliable, budget-friendly place to stay.
                </p>
               
                <div className="rx-about-inner-box">
                  <div className="row mb-minus-24">
                    <div className="col-sm-4 col-12 rx-575-50 mb-24">
                      <div className="rx-about-box">
                        <h5>5K+</h5>
                        <p>Happy Residents</p>
                      </div>
                    </div>
                    <div className="col-sm-4 col-12 rx-575-50 mb-24 mt-24">
                      <div className="rx-about-box">
                        <h5>15K+</h5>
                        <p>Visitors</p>
                      </div>
                    </div>
                    <div className="col-sm-4 col-12 rx-575-50 mb-24">
                      <div className="rx-about-box">
                        <h5>50+</h5>
                        <p>Community Events</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default AboutSection;
